import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { MAIN_SITE_URL } from '@/mocks/categories';

export default function ArticlePromo() {
  const { t } = useTranslation();

  return (
    <>
      {/* Featured guide */}
      <section className="bg-white py-16 md:py-20">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <div className="grid grid-cols-1 items-center gap-8 rounded-lg border border-stone-100 bg-cream p-6 md:grid-cols-[1fr_auto] md:p-10">
            <div>
              <span className="text-xs font-semibold uppercase tracking-widest text-emerald-700">
                {t('featuredGuide.eyebrow')}
              </span>
              <h2 className="mt-3 font-display text-2xl font-bold text-stone-900 md:text-3xl">
                {t('featuredGuide.title')}
              </h2>
              <p className="mt-3 max-w-2xl text-sm leading-relaxed text-stone-600 md:text-base">
                {t('featuredGuide.excerpt')}
              </p>
            </div>
            <div className="flex flex-col gap-3 sm:flex-row md:flex-col">
              <Link
                to="/usfans-spreadsheet-guide"
                className="inline-flex items-center justify-center whitespace-nowrap rounded-md bg-emerald-600 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-emerald-700"
              >
                {t('featuredGuide.readMore')}
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="bg-stone-900 py-16 md:py-20">
        <div className="mx-auto max-w-3xl px-4 text-center md:px-6">
          <h2 className="font-display text-2xl font-bold text-white md:text-3xl">
            {t('finalCta.title')}
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-stone-300 md:text-base">
            {t('finalCta.copy')}
          </p>
          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <a
              href={MAIN_SITE_URL}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center whitespace-nowrap rounded-md bg-emerald-600 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-emerald-700"
            >
              {t('finalCta.ctaPrimary')}
              <i className="ri-arrow-right-up-line ml-2"></i>
            </a>
            <a
              href={MAIN_SITE_URL}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center whitespace-nowrap rounded-md border border-white/20 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-white/10"
            >
              {t('finalCta.ctaSecondary')}
            </a>
          </div>
        </div>
      </section>
    </>
  );
}